import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { getCdnUrl } from '../../../data/api/cdn'

import { EntryModalProps } from '../../../data/entries/types'
import { AppState } from '../../../data/state'
import RocketModal from '../../../elements/modals/RocketModal'

interface RocketModalProps extends EntryModalProps {
  view: boolean
  setRocketModal: (view: boolean) => void
}

class EntryRocketModal extends React.Component<RocketModalProps> {
  public componentDidMount() {
    this.props.setRocketModal(true)
  }

  public componentDidUpdate(props: RocketModalProps) {
    if (!this.props.view) {
      this.props.onClose()
    }
  }

  public render() {
    return <RocketModal backgroundImage={getCdnUrl('background-planet.jpg')} />
  }
}

export default connect(
  (state: AppState) => ({
    view: state.ui.viewRocketModal,
  }),
  dispatch => ({
    setRocketModal: (view: boolean) => {
      dispatch(actions.change('ui.viewRocketModal', view))
    },
  }),
)(EntryRocketModal)
